export const SET_IMPACT = "SET_IMPACT";

export const setImpact = (impact) => {
  return {
    type: SET_IMPACT,
    payload: impact,
  };
};
